import * as React        from 'react';
import { Route, Switch } from 'react-router-dom';

import { useCommon } from './providers/common';
import Router        from './router';

const Routes = function() {
  const common = useCommon();

  if (!common.pagesLoaded) {
    return null;
  }

  return (
    <Switch>
      <Route
        exact
        component={Router}
        path={`/:page/${DOOR_PREFIX}:door`}
      />
      <Route
        exact
        component={Router}
        path={'/:page/:urlKey'}
      />
      <Route
        exact
        component={Router}
        path={'/:page'}
      />
      <Route
        exact
        component={Router}
        path={'/'}
      />
      <Route
        component={Router}
        path={'/:page/:urlKey'}
      />
    </Switch>
  );
};

export default Routes;